export const ERROR_CODE = {
  NOT_FOUND: "not-found",
  ACCESS_DENIED: "access-denied",
  REQUEST_BLOCKED: "REQUEST_BLOCKED",
  FILE_PROCESSING: "file-processing",
  FILE_PROTECTED: "file-protected",
  RESOURCE_LOCKED: "resource-locked",
  ASSIGNMENT_NOT_PAUSED: "AssignmentNotPaused",
  MISSING_BROWSER_TAB_UUID: "missing-browser-tab-uuid",
  LESSON_UNPUBLISHED: "LessonUnpublished",
  ALS_APP_DISABLED: "als-app-disabled",
  ALS_PERMISSION_DENIED: "als-permission-denied",
};
